import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SidebarContent = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  display: flex;
`;

export const SidebarTopbar = styled.header`
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  min-height: 40px;
  max-height: 40px;

  display: flex;
  align-items: center;

  border-bottom: 1px solid var(--neutral-3);
`;

export const SidebarToolbar = styled.aside`
  box-sizing: border-box;
  width: 45px;
  min-width: 45px;
  max-width: 45px;
  height: 100%;
  padding: 5px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  border-right: 1px solid var(--neutral-3);
`;

export const SidebarDrawer = styled.aside`
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
`;

export const MainContent = styled.section`
  position: relative;
  box-sizing: border-box;
  flex: 1;
  height: 100%;

  display: flex;
  flex-direction: column;
`;

export const Topbar = styled.header`
  z-index: 3;
  box-sizing: border-box;
  width: 100%;
  flex-basis: 40px;
  max-height: 40px;
  padding: var(--padding-1);

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: var(--neutral-2);
  border-bottom: 1px solid var(--neutral-3);
`;

export const Scene = styled.section`
  box-sizing: border-box;
  position: relative;
  flex: 1;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StateControllerContainer = styled.section`
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  width: calc(100% - 300px);
  padding: var(--padding-1);

  pointer-events: none;
  & > * {
    pointer-events: all;
  }
`;

export const Footer = styled.footer`
  z-index: 1;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  padding: 0 var(--padding-1);
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--main-2);
  font-family: var(--font-1);
  font-size: 11px;

  background-color: var(--neutral-2);
  border-top: 1px solid var(--neutral-3);

  .leftSideInfo {
    position: absolute;
    left: var(--padding-1);

    & > span {
      padding: 0 5px;
      opacity: 0.5;
    }
  }
`;
